import React, {Component} from 'react';

export default class UploadFile extends Component {

	state = {
		imgSrc : '#'
	}

	componentDidMount() {
		this.setState({
			imgSrc : this.props.element
		});
		
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			imgSrc : nextProps.element
		});
	}

	handleClick = () => {
		this.props.onCancel();
	}

	handleSaveClick = (e) => {
		e.persist();
		this.props.onSave(e);
	}

	render() {
		return(
			<div className="row" style={this.props.visibility ? {display:'block'} : {display: 'none'}}>
				<div className="col-md-12" style={{marginBottom : '20px'}}>
					<img id="showImageUpload" alt="show" src={this.state.imgSrc} style={{width: '100%'}} />
				</div>
				<div className="col-md-6">
					<button className="btn btn-block" onClick={this.handleClick}>Cancel</button>
				</div>
				<div className="col-md-6">
					<button className="btn green btn-block" onClick={this.handleSaveClick} value="upload">Save</button>
				</div>
			</div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/UserProfileModal/UploadFile.js
 **/